import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { ExcelUtils } from 'src/app/classes/ExcelUtils';
import { StocktakeItemInfo } from 'src/app/models/models';
import { Stocktake, Stocktake_Item, Store } from 'src/app/models/RestModels';
import { SearchObject } from 'src/app/services/Rest';
import { BaseComponent } from '../base/base.component';
import { Utils } from 'src/app/classes/Utils';


interface CResume
{
	item_count:number;
	stocktake_item_count:number;
	db_qty_sum:number;
	real_qty_sum:number;
	surplus_qty:number;
	surplus_item_count:number;
	missing_qty:number;
	missing_item_count:number;
	ok_item_sum:number;
	ok_item_count:number;
}

@Component
({
	selector: 'app-view-stocktake',
	templateUrl: './view-stocktake.component.html',
	styleUrls: ['./view-stocktake.component.css']
})
export class ViewStocktakeComponent extends BaseComponent implements OnInit
{
	stocktake:Stocktake = GetEmpty.stocktake();
	stocktake_item_info_list:StocktakeItemInfo[] = [];
	store:Store = GetEmpty.store();
	stocktake_item_search:SearchObject<Stocktake_Item> = this.getEmptySearch<Stocktake_Item>();

	cresume: CResume = {
		item_count:0,
		stocktake_item_count:0,
		db_qty_sum:0,
		real_qty_sum:0,
		surplus_qty:0,
		surplus_item_count:0,
		missing_qty:0,
		missing_item_count:0,
		ok_item_sum:0,
		ok_item_count:0,
	};

	ngOnInit(): void
	{
		this.subs.sink = this.getQueryParamObservable().pipe
		(
			mergeMap((response:ParamMap[])=>
			{
				let stocktake_id	= parseInt( response[1].get('stocktake_id') ) as number;
				this.stocktake_item_search = this.getSearch<Stocktake_Item>(response[0],[],[]);
				this.stocktake_item_search.eq.stocktake_id = stocktake_id;
				this.path = '/view-stocktake/'+stocktake_id;
				this.current_page = this.stocktake_item_search.page;

				return forkJoin
				({
					stocktake: stocktake_id == this.stocktake.id ? of(this.stocktake ) : this.rest.stocktake.get( stocktake_id ),
					stocktake_item: this.rest.stocktake_item_info.search(this.stocktake_item_search),
					stocktake_resume: this.rest.getReporte('getStocktakeResume',{stocktake_id:stocktake_id}).pipe(catchError(() => of(null))),
					store: this.rest.getStores()
				});
			})
		)
		.subscribe((response)=>
		{
			console.log( response.store.data );
			this.setPages(this.current_page, response.stocktake_item.total );
			this.stocktake	= response.stocktake;
			this.store		= response.store.data.find((s)=>s.id == this.stocktake.store_id) || GetEmpty.store();
			this.cresume	= response.stocktake_resume ?? this.cresume;
			this.stocktake_item_info_list = response.stocktake_item.data;
		}, (error)=>this.showError(error))
	}

	export()
	{
		this.is_loading = true;
		
		this.rest.stocktake_item_info.searchAll(this.stocktake_item_search)
		.subscribe({
			next: (response) =>
			{
				let stocktake_items = response.data;

				let rows = stocktake_items.map(item => {
					const row: any = {
						'Articulo': item.item.name,
						'Usuario': item.user.name,
					};
					if (this.rest.current_permission.view_stock) {
						row['Cant.sistema'] = item.stocktake_item.db_qty;
					}
					row['Cant. Inventariado'] = item.stocktake_item.real_qty;
					if (this.rest.current_permission.view_stock) {
						row['Diferencia'] = item.stocktake_item.real_qty - item.stocktake_item.db_qty;
					}
					row['Fecha'] = Utils.getDateString(item.stocktake_item.updated);
					return row;
				});

				let headers = ["Articulo", "Usuario"];
				if (this.rest.current_permission.view_stock) {
					headers.push("Cant.sistema");
				}
				headers.push("Cant. Inventariado");
				if (this.rest.current_permission.view_stock) {
					headers.push("Diferencia");
				}
				headers.push("Fecha");
				
				ExcelUtils.array2xlsx(rows, `Inventario-${this.stocktake.id}.xlsx`, headers);
				
				this.is_loading = false;
			},
			error: (error) => {
				this.showError(error);
				this.is_loading = false;
			}
		});
	}

}
